// src/utils/format.js

/**
 * Format a currency value.
 * Accepts numbers OR numeric strings (Laravel `decimal:X` casts return strings).
 */
export const formatCurrency = (n) => {
  const num = typeof n === "string" ? parseFloat(n) : n;
  if (typeof num !== "number" || Number.isNaN(num)) return "₱0";
  return `₱${num.toLocaleString("en-PH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Format a plain number (counts, totals, etc.).
 */
export const formatNumber = (n) => {
  const num = typeof n === "string" ? parseFloat(n) : n;
  if (typeof num !== "number" || Number.isNaN(num)) return "0";
  return num.toLocaleString("en-PH");
};

/**
 * Format a percentage.
 */
export const formatPercent = (n) => {
  const num = typeof n === "string" ? parseFloat(n) : n;
  if (typeof num !== "number" || Number.isNaN(num)) return "0%";
  return `${Math.round(num)}%`;
};